<template>
  <div class="modal-noti">
    <div style="" class="texto">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="86"
        height="86"
        viewBox="0 0 86 86"
        fill="none"
      >
        <circle
          cx="43"
          cy="43"
          r="41.9424"
          stroke="#FFB900"
          stroke-width="1.11514"
        />
        <path
          d="M38.0967 30.149C42.9985 25.2861 50.6685 24.8348 56.1123 28.8873L56.5391 28.4703C57.3118 27.7063 58.5572 27.7063 59.3184 28.4703C59.699 28.8409 59.9072 29.3391 59.9072 29.8717C59.9072 30.4042 59.6988 30.9016 59.3184 31.2721L58.915 31.6666C62.9861 37.0855 62.5129 44.6806 57.5996 49.5436L49.9883 57.0817C49.5039 57.568 49.2266 58.2052 49.2266 58.8883C49.2266 59.5714 49.4924 60.2193 49.9883 60.694L51.1875 61.8756C52.4329 63.1029 52.6286 65.0593 51.6484 66.4371C51.0487 67.2824 50.1142 67.8268 49.0762 67.9078C49.0069 67.9193 48.8915 67.9196 48.7764 67.9196C47.8423 67.9195 46.9542 67.5608 46.2969 66.901L41.833 62.4889L36.9893 58.4947C36.1012 59.0273 35.0747 59.3053 34.0137 59.3053C32.4682 59.3053 31.0029 58.7024 29.9072 57.6256C28.8118 56.5373 28.2002 55.0901 28.2002 53.5387C28.2002 52.4966 28.4773 51.4773 29.0078 50.5973L24.96 45.7926L20.9688 41.8444C20.2884 41.1729 19.9077 40.2232 19.9307 39.2623C19.9537 38.2898 20.3693 37.398 21.0957 36.7496C22.4913 35.5107 24.6371 35.5911 25.9981 36.9342L26.7588 37.6871C27.7853 38.7061 29.4577 38.706 30.4727 37.6871L38.0967 30.149Z"
          fill="url(#paint0_linear_8241_20417)"
        />
        <defs>
          <linearGradient
            id="paint0_linear_8241_20417"
            x1="40.7948"
            y1="26.144"
            x2="40.7948"
            y2="67.9196"
            gradientUnits="userSpaceOnUse"
          >
            <stop stop-color="#FFE480" />
            <stop offset="1" stop-color="#FFAE00" />
          </linearGradient>
        </defs>
      </svg>
      <h2 class="h1-default" style="color: var(--text-primary)">
        Tienes algunas notificaciones sin revisar
      </h2>
    </div>

    <div class="footerNoti">
      <BtnBComponent texto="Ignorar" @click="cerrar" />

      <router-link :to="`/notificaciones`">
        <BtnBComponent texto="Revisar" @click="cerrar" />
      </router-link>
    </div>
  </div>
</template>
<script>
import BtnBComponent from "../Buttons/BtnBComponent.vue";
export default {
  name: "ModalNotiSinLeerComponent",
  props: {
    cerrar: Function,
  },
  components: {
    BtnBComponent,
  },
};
</script>
<style scoped>
.modal-noti {
  border: 1px solid var(--bordecard);
  padding: var(--gap30) 2.19vw;
  height: var(--heightModal);
  margin: auto;
  width: var(--widthModal);
  display: flex;
  flex-direction: column;
  justify-content: center;
  gap: var(--gap25);
}
.texto {
  display: flex;
  flex-direction: column;
  justify-content: center;
  gap: var(--gap25);
  align-items: center;
}
svg {
  height: 12.55vh;
  width: 6.22vw;
}

.footerNoti {
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  gap: var(--gapH24);
  animation: footerFadeUp 0.35s ease;
}

@keyframes footerFadeUp {
  from {
    opacity: 0;
    transform: translateY(8px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.footerNoti :deep(button) {
  transition:
    transform 0.2s ease,
    box-shadow 0.2s ease,
    filter 0.2s ease;
}

.footerNoti :deep(button:hover) {
  transform: translateY(-4px);
}

.footerNoti :deep(button:active) {
  transform: translateY(-1px);
}

.texto svg {
  animation: iconPulse 2.5s ease-in-out infinite;
}

@keyframes iconPulse {
  0% {
    transform: scale(1);
  }
  50% {
    transform: scale(1.08);
  }
  100% {
    transform: scale(1);
  }
}

.footerNoti {
  animation: buttonsFade 0.4s ease;
}

@keyframes buttonsFade {
  from {
    opacity: 0;
    transform: translateY(6px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

@media (max-width: 990px) {
  .modal-noti {
    width: 100%;
  }
}

@media (max-width: 770px) {
  .texto {
    display: flex;
    flex-direction: row;
    justify-content: center;
    gap: var(--gap5);
    align-items: center;
    margin: auto;
  }
  .texto h2 {
    width: 80%;
  }
  .modal-noti {
    padding: var(--gap20) var(--gapHM15);
    height: auto;
    border-radius: 8px;
    width: 100%;
    gap: var(--gap20);
  }
  .h2-default {
    font-size: 18px !important;
    font-weight: 600 !important;
  }

  .footerNoti {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    gap: var(--gap10);
  }

  svg {
    height: var(--margin40);
    width: 40px;
  }
}
</style>
